export default 'M17.329 18.743A9.96 9.96 0 0111 21C5.477 21 1 16.523 1 11S5.477 1 11 1s10 4.477 10 10a9.959 9.959 0 01-2.257 6.329l3.964 3.964a1 1 0 01-1.414 1.414l-3.964-3.964zM19 11a8 8 0 11-16 0 8 8 0 0116 0z';
